var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3961 21.4074H7.60391C5.80121 21.4074 4.33984 19.8416 4.33984 17.9102V5.08705C4.33984 3.1556 5.80121 1.58984 7.60391 1.58984H17.3961C19.1988 1.58984 20.6602 3.1556 20.6602 5.08705V17.9102C20.6602 19.8416 19.1988 21.4074 17.3961 21.4074ZM10.8632 9.40912C11.2736 9.03954 11.3067 8.40724 10.9371 7.99684C10.5675 7.58644 9.9352 7.55335 9.5248 7.92293L8.34338 8.98685L8.0932 8.76144C7.68289 8.39176 7.05059 8.4247 6.6809 8.83501C6.31122 9.24532 6.34416 9.87762 6.75447 10.2473L7.67385 11.0757C8.05421 11.4183 8.63196 11.4184 9.01241 11.0758L10.8632 9.40912ZM10.8632 14.4111C11.2736 14.0415 11.3067 13.4092 10.9371 12.9988C10.5675 12.5884 9.9352 12.5553 9.5248 12.9249L8.34338 13.9888L8.0932 13.7634C7.68289 13.3937 7.05059 13.4267 6.6809 13.837C6.31122 14.2473 6.34416 14.8796 6.75447 15.2493L7.67385 16.0776C8.05421 16.4203 8.63196 16.4204 9.01241 16.0778L10.8632 14.4111ZM13.2344 9.50001C13.2344 8.94772 13.6821 8.50001 14.2344 8.50001H17.3458C17.8981 8.50001 18.3458 8.94772 18.3458 9.50001C18.3458 10.0523 17.8981 10.5 17.3458 10.5H14.2344C13.6821 10.5 13.2344 10.0523 13.2344 9.50001ZM14.2344 13.5C13.6821 13.5 13.2344 13.9477 13.2344 14.5C13.2344 15.0523 13.6821 15.5 14.2344 15.5H17.709C18.2613 15.5 18.709 15.0523 18.709 14.5C18.709 13.9477 18.2613 13.5 17.709 13.5H14.2344Z",
    fill: "#3158F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormsIcon);
export default __webpack_public_path__ + "static/media/forms-icon.cb844b1036243e6b177a152ce1a14616.svg";
export { ForwardRef as ReactComponent };